<nz-spin [nzSpinning]="submitted" nzSize="large">
  <form nz-form [nzLayout]="'vertical'" (ngSubmit)="showCreateDatasetConfirm()" [formGroup]="datasetForm"
        aria-labelledby="sub-title" class="dataset-form">
    <nz-form-item>
      <nz-form-label nzRequired nzFor="car-make">Car Make</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <nz-select nzPlaceHolder="Car Make" formControlName="carMake" (ngModelChange)="onCarMakeChange($event)"
                   nzSize="large">
          <nz-option *ngFor="let make of (vehicleMakes$ | async)" [nzValue]="make.name"
                     [nzLabel]="make.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <label class="carvry-label" *ngIf="modelList && f.isMultipleCarModels.value">
      {{modelList.length}} Models Found!
    </label>

    <label nz-checkbox formControlName="isMultipleCarModels" class="carvry-checkbox"
           (nzCheckedChange)="onIsMultipleModelsChange($event)">
      Create datasets for multiple models
    </label>

    <nz-form-item *ngIf="!f.isMultipleCarModels.value" class="p-b-20">
      <nz-form-label nzRequired nzFor="car-model">Car Model</nz-form-label>
      <nz-form-control [nzXs]="24" nzSpan="24">
        <nz-select nzPlaceHolder="Car Model" formControlName="carModel" nzSize="large">
          <nz-option *ngFor="let model of modelList" [nzValue]="model.name" [nzLabel]="model.name"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <label nz-checkbox formControlName="shouldRefreshSegments" class="carvry-checkbox">
      Refresh Segments
    </label>

    <label nz-checkbox formControlName="shouldRefreshListings" class="carvry-checkbox p-b-35">
      Refresh Listings
    </label>

    <div nz-row>
      <div nz-col nzSpan="12" nzOffset="6">
        <button nz-button nzType="primary" nzSize="large" nzBlock [nzLoading]="submitted" type="submit"
                [disabled]="submitted || datasetForm.invalid" [class.btn-pulse]="submitted">
          Create Dataset
        </button>
      </div>
    </div>
  </form>
</nz-spin>
